export default {
  GET_PRACTICE_USERS_REQUEST: "GET_PRACTICE_USERS_REQUEST",
  GET_PRACTICE_USERS_SUCCESS: "GET_PRACTICE_USERS_SUCCESS",
  GET_PRACTICE_USERS_FAIL: "GET_PRACTICE_USERS_FAIL",

  GET_PRACTICE_SUBJECTS_REQUEST: "GET_PRACTICE_SUBJECTS_REQUEST",
  GET_PRACTICE_SUBJECTS_SUCCESS: "GET_PRACTICE_SUBJECTS_SUCCESS",
  GET_PRACTICE_SUBJECTS_FAIL: "GET_PRACTICE_SUBJECTS_FAIL",

  GET_ACTIVE_SUBSCRIPTIONS_REQUEST: "GET_ACTIVE_SUBSCRIPTIONS_REQUEST",
  GET_ACTIVE_SUBSCRIPTIONS_SUCCESS: "GET_ACTIVE_SUBSCRIPTIONS_SUCCESS",
  GET_ACTIVE_SUBSCRIPTIONS_FAIL: "GET_ACTIVE_SUBSCRIPTIONS_FAIL",

  CREATE_PRACTICE_SUBSCRIPTION_REQUEST: "CREATE_PRACTICE_SUBSCRIPTION_REQUEST",
  CREATE_PRACTICE_SUBSCRIPTION_SUCCESS: "CREATE_PRACTICE_SUBSCRIPTION_SUCCESS",
  CREATE_PRACTICE_SUBSCRIPTION_FAIL: "CREATE_PRACTICE_SUBSCRIPTION_FAIL",

  SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_REQUEST:
    "SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_REQUEST",
  SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_SUCCESS:
    "SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_SUCCESS",
  SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_FAIL:
    "SEND_BULK_CUSTOM_MESSAGE_TO_PHONES_FAIL",

  PRACTICE_USERS_LOADING: "PRACTICE_USERS_LOADING",
  PRACTICE_SUBJECTS_LOADING: "PRACTICE_SUBJECTS_LOADING",
  ACTIVE_SUBSCRIPTIONS_LOADING: "ACTIVE_SUBSCRIPTIONS_LOADING",
  CREATE_SUBSCRIPTION_LOADING: "CREATE_SUBSCRIPTION_LOADING",
  SEND_BULK_MESSAGE_LOADING: "SEND_BULK_MESSAGE_LOADING",
};
